module.exports = __webpack_public_path__ + "img/progress-4.fffed4df.svg";